import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const Spinner = styled.div`
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
  border: 4px solid var(--color-primary);
  border-top: 4px solid ${props => props.color || '#3498db'};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

function Loader({
    size = '40px',
    color,
    className
}) {
    return (
        <LoaderOverlay className={className}>
            <LoaderContainer>
                <Spinner size={size} color={color} />
            </LoaderContainer>
        </LoaderOverlay>
    );
}

Loader.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
};

Loader.defaultProps = {
    size: '40px',
    color: 'var(--primary-color)',
    className: '',
};

export default Loader;
